import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, GetToken } from './types';

export const INITIAL_STATE: GetToken = {
	status: 0,
	data: '',
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): GetToken {
	return produce(state, draft => {
		switch (action.type) {
			case Types.GET_E_CPF_TOKEN_REQUEST: {
				break;
			}

			case Types.GET_E_CPF_TOKEN_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.GET_E_CPF_TOKEN_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.GET_E_CPF_TOKEN_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
